import { Cirus } from "@/classes/Http";
import { IsBoolean, IsDateString, IsOptional, IsString, validate } from "class-validator";
import { Message } from "element-ui";

const errorMessages : any = {
    name:  "لطفا نام همکار را صحیح وارد کنید",
    birthdate:  "لطفا تاریخ تولد را صحیح وارد کنید",
    father:  "لطفا نام پدر را صحیح وارد کنید",
    username:  "لطفا نام کاربری را صحیح وارد کنید",
    mobile:  "لطفا شماره همراه را صحیح وارد کنید",
    email:  "لطفا ایمیل را صحیح وارد کنید",
    avatar_id:  "تصویر به درستی آپلود نشده است. لطفا فرم را ببندید و دوباره باز کنید.",
    receiveSystemSms:  "مشکلی در درخواست شما وجود دارد.",
    receiveSystemEmail:  "مشکلی در درخواست شما وجود دارد.",
    receiveNotification:  "مشکلی در درخواست شما وجود دارد.",
}

export class CreateInstanceUserBody {
    constructor(body: CreateInstanceUserBody) {
        this.name=body.name;
        this.birthdate=body.birthdate;
        this.father=body.father;
        this.username=body.username;
        this.mobile=body.mobile;
        this.email=body.email;
        this.avatar_id=body.avatar_id;
        this.receiveSystemSms=body.receiveSystemSms;
        this.receiveSystemEmail=body.receiveSystemEmail;
        this.receiveNotification=body.receiveNotification;
    }
    @IsString()
    name: string;

    @IsDateString()
    @IsOptional()
    birthdate?: string;

    @IsString()
    @IsOptional()
    father: string;

    @IsString()
    username!: string;

    @IsString()
    mobile!: string;

    @IsString()
    @IsOptional()
    email: string;

    @IsString()
    @IsOptional()
    avatar_id: string;

    @IsBoolean()
    receiveSystemSms: boolean;

    @IsBoolean()
    receiveSystemEmail: boolean;

    @IsBoolean()
    receiveNotification: boolean;
}

export async function createUser(instance_id: number, params: CreateInstanceUserBody) {
    params = new CreateInstanceUserBody(params);    
    const errors = await validate(params);
    console.log(errors);
    
    if (errors.length>0)  {
        Message.error(errorMessages[errors[0].property])
        throw new Error("اطلاعات وارد شده صحیح نمی ‌باشد.");
    }
    const path = `/instance/${instance_id}/user`;
    return Cirus.post(path, params);
}